import umami from '@umami/node';

if (typeof window !== "undefined") {
  umami.init({
    websiteId: process.env.NEXT_PUBLIC_UMAMI_ID!,
    hostUrl: process.env.NEXT_PUBLIC_UMAMI_URL!,
  });
}

export const tracker = umami;
